import { type RouteLocationRaw } from 'vue-router'
import { authRoutes, router } from '.././router'
import { type QrErrorCode } from '../state'
import { postGetBody, type ProblemDetailsResponse } from '@webapp2/shared/services/api'
import { authenticated, type AuthenticatedResponse, loginRequestTimeoutInMs } from './authentication-service'
import { trackEvent } from './log-rocket-service'
import * as questBridge from './quest-bridge'

type QrLoginResult = { loggedIn: boolean; route: RouteLocationRaw }

export async function qrLogin(qrCode: string) {
  const { loggedIn, route } = await redeemQrCode(qrCode).catch((error: unknown) => {
    questBridge.qrLoginResult(false)
    throw error
  })
  questBridge.qrLoginResult(loggedIn)
  await router.push(route)
}

async function redeemQrCode(qrCode: string): Promise<QrLoginResult> {
  const parts = qrCode.split(':')
  if (parts.length !== 2) {
    return failure('Invalid')
  }
  const token = parts[1]
  let response: AuthenticatedResponse | ProblemDetailsResponse | undefined
  try {
    response = await postGetBody<AuthenticatedResponse | ProblemDetailsResponse>(
      'login-qr-token',
      { token },
      { timeoutInMs: loginRequestTimeoutInMs }
    )
  } catch (error) {
    trackEvent('QrLoginFailed', { error: String(error) })
    return failure('Unreachable')
  }
  if (response && 'user' in response) {
    return { loggedIn: true, route: await authenticated(response, 'qr', response.redirectPath ?? undefined) }
  }
  return failure(response ? (response.title as QrErrorCode) : 'Invalid')
}

function failure(qrErrorCode: QrErrorCode): QrLoginResult {
  return { loggedIn: false, route: { name: authRoutes.login.name, state: { qrErrorCode } } }
}
